export const ModifyOrderModalComponent = {
    template: `
        <order-summary>
            <button
                class="button button-link"
                ng-click="$ctrl.togglePopup()"
            >Edit</button>
        </order-summary>
        <slide-modal
            on-cancel="$ctrl.cancelChanges()"
            open="$ctrl.popup"
            title="Order Details"
        >
            <modal-content>
                <modify-order></modify-order>
            </modal-content>
            <modal-action>
                <oo-button
                    is-loading="$ctrl.isLoading"
                    types="button-primary button-full button-lg"
                    button-click="$ctrl.confirm()"
                >
                    Update Order
                </oo-button>
            </modal-action>
        </slide-modal>
    `,
    controller: class {
        constructor(cartDisplayService, cartService, ModalService) {
            'ngInject';

            Object.assign(this, { cartDisplayService, cartService, ModalService });

            this.cartDisplay = cartDisplayService.displayData;
            this.isLoading = false;
            this.popup = false;
        }

        cancelChanges() {
            this.cartDisplayService.rollback()
                .then(() => this.togglePopup());
        }

        confirm() {
            this.isLoading = true;
            this.cartService
                .configureCart(
                    this.cartDisplay.diningOption,
                    this.cartDisplay.fulfillmentType,
                    this.cartDisplay.fulfillmentMoment,
                    true
                ).then(
                    () => this.onConfirmSuccess(),
                    () => this.cancelChanges()
                ).finally(
                    () => this.isLoading = false
                );
        }

        onConfirmSuccess() {
            this.cartDisplayService.updateFulfillmentTimeFromCart();
            this.togglePopup();
        }

        togglePopup() {
            this.popup = !this.popup;
        }
    }
};
